export const serverQA = "https://qa.zingproduction.com/";
export const serverUrl = process.env.REACT_APP_API_URL || serverQA;
export const zingApiAuthKey =
    process.env.REACT_APP_BACKEND_V3_AUTH_KEY || "5h3Ejm9t.81m4k5QAymY1mO5Ma4DNC31YglxZw7uJ";
export const poraTestMechanismUrl = "https://api.pora.ai/counters/";

export const PALTA_CREATE_CUSTOMER_URL =
    "https://ws.prod.paltabrain.com/v1/stripe-customers-webhook";
export const PALTA_CREATE_SUBSCRIPTION_URL =
    "https://ws.prod.paltabrain.com/v1/stripe-subscriptions-webhook";
export const PALTA_CANCEL_SUBSCRIPTION_URL = "https://ws.prod.paltabrain.com/v1/unsubscribe";
export const PALTA_SEND_DEEPLINK_URL = "https://ws.prod.paltabrain.com/v1/send-deep-link-to-email";
export const PALTA_GET_PRICES_URL = "https://ws.prod.paltabrain.com/v1/prices";
export const PALTA_CREATE_ONE_TIME_PAYMENT_URL =
    "https://ws.prod.paltabrain.com/v1/stripe/initiate-one-off-payment";

const STRAPI_URL = "https://committed-bracelet-61837cee70.strapiapp.com/api/";
export const STRAPI_QUESTIONS_GROUPS_URL =
    STRAPI_URL + "questions-groups?populate[questions][populate][0]=answers";
